<template>
  <div class="contractList">
    <van-sticky>
      <div
        class="contractListNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">{{
          identityType == 1 ? "个人代理人合同列表" : "企业代理人合同列表"
        }}</span>
      </div>
    </van-sticky>
    <div class="content" v-if="loaded">
      <div v-if="dataList.length > 0">
        <div
          class="item"
          @click="seeContract(item.contract_id)"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <div class="itemTop">
            <span>合同编码 {{ item.contract_number }}</span>
          </div>
          <h3>{{ item.contract_name }}</h3>
          <p>
            合同有效期：{{ item.validity_start }} 至 {{ item.validity_end }}
          </p>
        </div>
      </div>
      <!-- 无数据 -->
      <div class="noData" v-else-if="!noNetwork">
        <img src="./../../../assets/decoration/noData.png" alt="" />
        <p>暂无相关数据</p>
      </div>
      <!-- 请求错误or无网络 -->
      <div class="noNetwork" v-else>
        <img src="./../../../assets/decoration/noNetwork.png" alt="" />
        <p>您的网络不太给力，点击刷新再试一下～</p>
        <button @click="getData()">刷新</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      dataList: [],
      loaded: false,
      noNetwork: false,
      identityType: 1,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getIdentityType();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取代理人当前身份
    getIdentityType() {
      this.$api.get("decoration/member/city/agent/switch/role").then((res) => {
        this.identityType = res.type;
        this.getData();
      });
    },
    getData() {
      this.$api
        .get("decoration/member/contract/agent/list", {
          type: this.identityType,
        })
        .then((res) => {
          this.dataList = res;
          this.loaded = true;
        })
        .catch((err) => {
          this.loaded = true;
          this.noNetwork = true;
        });
    },
    seeContract(contract_id) {
      this.$router.push({
        path: "/decoration/deputy/seeContract",
        query: {
          contract_id: contract_id,
        },
      });
    },
  },
};
</script>
<style lang="less">
.contractList {
  height: 100%;
  background: #f5f6ff;
  .contractListNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin-top: 12px;
    div {
      .item {
        margin: 0px 16px 12px;
        padding: 0 16px;
        background: #ffffff;
        border-radius: 12px;
        position: relative;
        .itemTop {
          border-bottom: 1px solid #f0f1ff;
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          span {
            font-size: 13px;
            color: #333333;
            line-height: 18px;
          }
        }
        h3 {
          font-size: 15px;
          font-weight: 700;
          color: #333333;
          line-height: 21px;
          margin: 15px 0;
        }
        p {
          font-size: 13px;
          color: #999999;
          line-height: 18px;
          padding-bottom: 24px;
        }
        img {
          width: 64px;
          height: 64px;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
    .noData,
    .noNetwork {
      margin-top: 64px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 149px;
        height: 125px;
      }
      p {
        font-size: 13px;
        color: #999999;
        line-height: 18px;
        margin-top: 32px;
      }
      button {
        width: 92px;
        height: 32px;
        background: rgba(88, 83, 233, 0.1);
        border-radius: 25px;
        line-height: 32px;
        color: #5853e9;
        font-size: 14px;
        margin-top: 16px;
        border: none;
      }
    }
  }
}
</style>